export default {
  courseList: state => state.courseList
}
